import React, { useEffect, useContext } from "react";
import * as XLSX from "xlsx";
import _ from "lodash";
import { Button, Tooltip } from "@material-ui/core";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import GetAppIcon from "@material-ui/icons/GetApp";
import "../../styles/form.scss";
import CircularProgress from "@material-ui/core/CircularProgress";
import { RequestContext } from "../../context/RequestContext";

const SPECIAL_VALUES = {
  autoComplete: (v) => ({ entry: v }),
  boolean: (v) => /^(true|yes|1|y)$/i.test(v.trim()),   
};

const CUSTOM_REF={
  list:(obj)=> _.get(obj,"label", obj)
};

const STRING_TYPE = ["text", "textarea"];

const ImportSources = ({ sourceLocation, onImportSources, metaData, setImportError }) => {  
  //Adding initial states
  const {downloading, getTemplate} = useContext(RequestContext);

  const onPaste = (event) => {
    let element = document.getElementById(_.get(event.target, "id"));
    if (/^(input|textarea)$/i.test(event.target.nodeName) && element === document.activeElement) {
      return;
    }
    try {
      let tableContainer = document.createElement("div"),
        workbook,
        sources;

      tableContainer.innerHTML = event.clipboardData.getData("text/html");
      _.forEach(tableContainer.querySelectorAll("table tr"), function (row) {
        if (!row.textContent.trim()) {
          row.parentElement.removeChild(row);
        }
      });
      workbook = XLSX.utils.table_to_book(
        tableContainer.querySelector("table")
      ); // jshint ignore:line
      sources = convertToMorphSources(workbookToJSON(workbook));
      tableContainer.remove();
      onImportSources(sources);
    } catch (e) {
      console.log(e, "error")
    }
  };

  useEffect(() => {
    document.addEventListener('paste', onPaste);
    return () => {
      document.removeEventListener('paste', onPaste)
    }
  })
  const onFileChange = (e) => {
    e.preventDefault();
    // Check this condition why is is not working for now i am making true
    // var isValidSource = _.contains(
    //   SUPPORTED_MIME_TYPES,
    //   e.target.files[0].type
    // );
    let fileDom = e.target || _.get(e, "srcElement");
    // Need to look into this
    // setImportSource(fileDom.files.split("\\").pop());
    onImport(fileDom.files[0]);
  };

  const onImport = (file) => {
    let reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = (e) => {
      try {
        let data = e.target.result,
          workbook = XLSX.read(data, { type: "binary" }),
          sources = convertToMorphSources(workbookToJSON(workbook), true);
        onImportSources(sources);
      } catch (err) {
        console.log(err);
      }
    };
  };

  const getOldKeyValue = (ref, row, label) => {
    switch (ref) {
      case 'assetFilename':
        return row["sourceFilename"] || row[ref] || row[label]
      case 'estimatedRuntime':
        return row["approximateRunTime"] || row[ref] || row[label]
      default:
        return row[ref] || row[label]
    }
  }  
  const convertToMorphSources = (jsonSheet, hasMeta = false) => {
    let sheetNames = Object.keys(jsonSheet);
    let sheet = jsonSheet[_.first(sheetNames)];   
    const importLabel = _.get(sourceLocation, "importLabel");
    const rows = hasMeta ? sheet.slice(1) : sheet;
    let sources = [];
    _.map(rows, (row, index) => {
      let sourceObj = {}, flag = true;
      _.map(metaData, (meta) => {
        const ref = _.get(meta, "ref"); 
        const label = _.get(importLabel, ref);
        let field = meta;
        //Need to change sourceFilename to assetFilename in Excel template
        //This is temp fix need to remove this once changed in excel file
        let data = getOldKeyValue(ref, row, label);
        if (!_.isEmpty(data) || !_.isNil(data)) {
          if (SPECIAL_VALUES[field.type]) {
            sourceObj[ref] = SPECIAL_VALUES[field.type](data);
          } else if (CUSTOM_REF[field.type] && !_.get(field, "isEditable", false)) {
            const findRefObj = _.find(field.referenceDataSource, (val) => { return _.toLower(_.get(val,"label",val))  === _.toLower(data) })
            sourceObj[ref] = CUSTOM_REF[field.type](findRefObj);
            if (_.has(field, 'reveal', false)) {
              const sourceIDValue = sourceObj[_.get(field, 'ref', '')]
              const component = _.find(field.reveal, (item) => _.get(item, "refData") === sourceIDValue);
              const revealKey = component?.components[0];
              const idValue = getOldKeyValue('idNumber', row, importLabel['idNumber']);
              if (idValue) {
                sourceObj[revealKey] = idValue;
              } else {
                flag = false
              }
            }
          }
          else {
            sourceObj[ref] = _.includes(STRING_TYPE, field.type, false) ? _.toString(data) : data;
          }
        } else if (_.get(field, "required")) {
          flag = false;
        }
      });
      if (flag) {
        sources.push(sourceObj);
      }
    });
    setImportError(_.size(rows) !== _.size(sources))
    return _.size(rows) !== _.size(sources) ? [] : sources;
  };

  const workbookToJSON = (workbook) => {
    let result = {};
    workbook.SheetNames.forEach(function (sheetName) {
      let roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
      if (roa.length > 0) {
        result[sheetName] = roa;
      }
    });
    return result;
  };

  return (
    <div className="importSourcesDiv">     

      <label htmlFor="file">
        <input
          value={[]}
          type="file"
          id="file"
          onChange={onFileChange}
          style={{ display: "none" }}
        />
        <Button
          variant="contained"
          component="span"
          className="importSourcesButton"
          startIcon={<CloudUploadIcon />}
        >
          Import from Excel
        </Button>
      </label>

      <span style={{ marginLeft: "10px" }}>
        Excel templates can be imported or pasted into MORPh
      </span>
      {downloading ? (
        <CircularProgress
          className="importSourcesCircularProgress"
          color="primary"
          size={15}
        />
      ) : (
        <button
          className="importSourcesIconButton"
          onClick={(e) => getTemplate(sourceLocation)}
        >
          <Tooltip
            title="Download the template for this request"
            placement="top"
            arrow
          >
            <GetAppIcon color="primary" />
          </Tooltip>
          {/* Download the template for this request. */}
        </button>
      )}
      {/* <Tooltip
        title="Download the template for this request"
        placement="top"
        arrow
      >
        <a
          href={require("../../config/templates/" +
            _.get(sourceLocation, "template"))}
        >
          <GetAppIcon color="primary" /> */}
          {/* Download the template for this request. */}
        {/* </a>
      </Tooltip> */}
    </div>
  );
};

ImportSources.defaultProps = {
  keyCounter: 0,
  sourceLocation: "",
  onImportSources: (sourcesArray) => {/*We are sending onImportSources function as a default Prop*/},
  metaData: [],
  setImportError:(flag)=>{/*We are sending setImportError function as a default Prop*/}
};

export default ImportSources;
